/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    Card,
    Tabs,
    Row,
    Col,
    List as AntList,
    Empty,
    Upload,
    Icon,
    // Select,
    Button,
    Modal,
    Input,
    Typography,
    Tag,
} from "antd";

import {
    fetchDocumentsChecklist,
    uploadDocuments,
    fetchCaseDocuments,
    fetchCompanyDocuments,
    attachDocument,
    updateDocument,
    invalidateDocument,
    fetchDocumentTypes,
    requestDocuments
} from "store/actions";
import { STATE_STATUS } from "constants";
import { List } from "immutable";
import { LoaderSkeleton } from "components";
import { createDragSource, createDropTarget } from "hocs/drag-and-drop";
import { FILE_TYPE } from "constants/drag-drop-types";
import { getAuthToken } from "utilities/auth";
import { PermissionContextManager } from "hocs/permission-context-manager";
import { UI_PERMISSIONS } from "constants/index";
import { DocumentViewer } from "components/index";
import { DOCUMENT_CURRENT_STATUS } from "constants/enums";
import "./../../styles/documents-tab.css";
const ListItem = AntList.Item;

const Dragger = Upload.Dragger;
const { Paragraph } = Typography;
// const SanctionTypes = new Map({
//     pre_sanction: {
//         label: "Pre-Sanction",
//         value: "pre-sanction"
//     },
//     post_sanction: {
//         label: "Post-Sanction",
//         value: "post-sanction"
//     }
// });

const kycGuarantor = {
    "id": 3,
    "name": "KYC Guarantor",
    "type": "pre-sanction",
    "sort_order": 30,
    "documents": [
        {
            "id": 7,
            "document_name": "PAN Card",
            "is_mandatory": true,
            "sort_order": 10,
            "document_type": null,
            "document_document_type_option": [],
        },
        {
            "id": 6,
            "document_name": "Photograph",
            "is_mandatory": true,
            "sort_order": 10,
            "document_type": null,
            "document_document_type_option": []
        },
        {
            "id": 61,
            "document_name": "Aadhar Card M",
            "is_mandatory": false,
            "sort_order": 20,
            "document_type": null,
            "document_document_type_option": []
        },
        {
            "id": 63,
            "document_name": "Aadhar Card",
            "is_mandatory": true,
            "sort_order": 20,
            "document_type": 4,
            "document_document_type_option": [{
                "id": 12,
                "document_type_name": "Aadhar - Front M"
            },
            {
                "id": 13,
                "document_type_name": "Aadhar - Back M"
            }]
        }
    ]
};

class DirectFileUpload extends React.Component {
    state = {
        status: STATE_STATUS.IDLE
    };
    render() {
        return (
            <Upload
                {...{
                    directory: false, // Upload Directory Support
                    multiple: true, // Upload Multiple files support,
                    action:
                        `${process.env.BASE_URL}/company/documents/create/`,
                    showUploadList: false,
                    headers: {
                        Authorization: `Bearer ${getAuthToken().authToken}`
                    },
                    data: file => ({
                        file_name: file.name,
                        company: this.props.companyId
                    }),
                    onChange: ({ file }) => {
                        if (file.status === "uploading") {
                            this.setState({
                                status: STATE_STATUS.ENGAGED
                            });
                        }
                        if (file.status === "done") {
                            this.setState(
                                {
                                    status: STATE_STATUS.IDLE
                                },
                                () => this.props.uploadFiles([file.response])
                            );
                        }
                    }
                }}
            >
                <Button type={"default"} disabled={this.props.recreditViewOnlyPermission}>
                    Upload{" "}
                    <Icon
                        type={
                            this.state.status === STATE_STATUS.ENGAGED
                                ? "loading"
                                : "upload"
                        }
                        loading={this.state.status === STATE_STATUS.ENGAGED}
                    />
                </Button>
            </Upload>
        );
    }
}

DirectFileUpload.propTypes = {
    companyId: PropTypes.number,
    uploadFiles: PropTypes.func,
    updateDocument: PropTypes.func,
    recreditViewOnlyPermission: PropTypes.bool,
};

const DragSourceCard = createDragSource({
    dragType: FILE_TYPE,
    canDrag: props => {
        return props.draggable ? props.draggable : true;
    },
    dragResponse: () => ({
        dragType: FILE_TYPE
    }),
    // eslint-disable-next-line no-unused-vars
    dropResult: (props, { dropEffect, ...result }) => {
        let docId = result.document.toString().includes("-") ? result.document.toString().split("-")[0] : result.document;
        let payload = {
            ...result,
            document: docId,
            document_option: result.document.toString().includes("-") ? result.document.toString().split("-")[1] : null
        };
        props.attachDocument(
            docId,
            result.case, {
            ...payload,
            file: props.fileId,
            },
            {
                refresh_page: false
            }
        );
    }
})(Card);

class FileList extends React.Component {
    fileUpload = false;

    state = {
        fileName: null
    };

    getTitle = (file) => {
        return (
            <React.Fragment>
                <div className={"d-flex flex-direction-row justify-content-space-between"}>
                    <div style={{
                        textOverflow: "ellipsis",
                        overflow: "scroll"
                    }}>
                        <Paragraph
                            editable={!this.props.recreditViewOnlyPermission && {
                                onChange: (value) => {
                                    this.setState({
                                        fileName: value
                                    }, () => {
                                        this.props.changeName(
                                            file
                                                .set("file_name", this.state.fileName)
                                        );
                                    });
                                }
                            }}
                        >
                            {this.state.fileName || file.file_name + (file?.document?.document_name ? " (" + file?.document?.document_name + ")" : "")}
                        </Paragraph>
                    </div>
                </div>
                <div className={"d-flex flex-direction-row justify-content-space-between"}>
                    <Button className={"mr-5"} type={"link"} onClick={() => this.props.viewDoc(file)}>{"View"}</Button>
                    <Button className={"mr-5"} type={"link"} target={"_blank"} href={file.file}>{"Download"}</Button>
                    {this.props.isUserAllowedToEdit && this.props.editDocumentAttached && !this.props.recreditViewOnlyPermission ? <Button type={"link"} onClick={() => {
                        this.props.invalidateDocument(
                            file
                        );
                    }}>{"Delete"}</Button> : null}
                </div>
                {file.is_valid !== null && file.is_valid === false ?
                    <div>
                        <Tag color={"red"} className={"mr-5"}>
                            {"Rejected"}
                        </Tag>
                        {file.remarks}
                    </div>
                    : null
                }
            </React.Fragment>
        );
    }

    getStyle = (_) => {
        return _.is_valid !== null && _.is_valid === false ? {
            borderBottom: "2px solid red"
        } : null;
    }

    render() {
        if(!this.props.draggable) {
            return null;
        }

        return (
            <Card
                title={"Files"}
                style={{
                    maxHeight: "1000px",
                    position: "sticky",
                    overflowY: "scroll"
                }}
            >
                <Row>
                    {/* {this.props.editDocumentAttached ? (
                        <Col span={24} className={"mb-5"}>
                            <Dragger

                                {...{
                                    directory: false, // Upload Directory Support
                                    multiple: true, // Upload Multiple files support,
                                    action:
                                        `${process.env.BASE_URL}/company/documents/create/`,
                                    showUploadList: true,
                                    headers: {
                                        Authorization: `Bearer ${
                                            getAuthToken().authToken
                                        }`
                                    },
                                    data: file => ({
                                        file_name: file.name,
                                        company: this.props.companyId
                                    }),
                                    onChange: ({ file }) => {
                                        if (file.status === "done") {
                                            this.props.uploadFiles([file.response]);
                                        }
                                    }
                                }}
                            >
                                <p className="ant-upload-drag-icon">
                                    <Icon type="inbox" />
                                </p>
                                <p className="ant-upload-text">
                                    Click or drag file to this area to upload
                                </p>
                            </Dragger>
                        </Col>
                    ) : null} */}
                    <Col span={24}>
                        <AntList grid={{ column: 1 }}>
                            {!(
                                this.props.files && this.props.files.size > 0
                            ) ? (
                                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                ) : null}
                            {this.props.files
                                .map(_ => _.get("data"))
                                .sort((a, b) =>
                                    a.modified_date.isBefore(b.modified_date)
                                        ? 1
                                        : -1
                                )
                                .filter(_ => ![DOCUMENT_CURRENT_STATUS.get("Archived"), DOCUMENT_CURRENT_STATUS.get("Requested")].includes(_.document_status))
                                .map(_ => (
                                    <ListItem style={this.getStyle(_)} key={_.id}>
                                        <DragSourceCard
                                            // type={"inner"}
                                            size={"small"}
                                            title={this.getTitle(_)}
                                            fileId={_.id}
                                            className={
                                                "padless-card no-shadow w-100"
                                            }
                                            draggable={!!this.props.draggable}
                                            attachDocument={
                                                this.props.attachDocument
                                            }
                                        />
                                    </ListItem>
                                ))}
                        </AntList>
                    </Col>
                </Row>
            </Card>
        );
    }
}

FileList.propTypes = {
    companyId: PropTypes.number,
    files: PropTypes.object,
    uploads: PropTypes.object,
    uploadFiles: PropTypes.func,
    attachDocument: PropTypes.func,
    draggable: PropTypes.bool,
    invalidateDocument: PropTypes.func,
    caseId: PropTypes.number,
    viewDoc: PropTypes.func,
    changeName: PropTypes.func,
    isUserAllowedToEdit: PropTypes.bool,
    editDocumentAttached: PropTypes.bool,
    fetchDocumentTypes: PropTypes.func,
    recreditViewOnlyPermission: PropTypes.bool,
};

const DropTargetCard = createDropTarget({
    dropType: FILE_TYPE,
    dropResponse: props => {
        return {
            case: props.caseId,
            company: props.companyId,
            associate: props.associateId ? props.associateId : null,
            company_bank: props.bankId ? props.bankId : null,
            document: props.documentId,
            document_type: props.documentType,
            is_valid: true
        };
    }
})(Card);

class DocumentsList extends React.Component {
    deactivateDocument = documentId => {
        const document = this.props.documents.find(_ => _.id === documentId);
        this.props.updateDocument(
            this.props.caseId,
            this.props.companyId,
            documentId,
            document.set("company", this.props.companyId).set("is_active", false).set("file", document.file && document.file.id).set("case" , this.props.caseId)
        );
    };
    uploadAndAttachFile = (documentId, documentType, files) => {
        let docId = documentId.toString().includes("-") ? documentId.toString().split("-")[0] :  documentId;
        let docOption = documentId.toString().includes("-") ? documentId.toString().split("-")[1] :  null;
        const result = {
            case: this.props.caseId,
            company: this.props.companyId,
            associate: this.props.associateId ? this.props.associateId : null,
            company_bank: this.props.bankId ? this.props.bankId : null,
            document: docId,
            document_option : docOption,
            document_type: documentType,
            is_valid: true
        };
        this.props.uploadFiles(files);
        files.map(_ =>
            this.props.attachDocument(result.document, result.case, {
                ...result,
                file: _.id
            })
        );
    };

    renderList = (_ , docOption) => {
        if(docOption){    
            return (
                <AntList itemLayout={"horizontal"}>
                    {this.props.documents.filter(__ => __.document ===  _.id && __.file.document_option == docOption.split("-")[1])
                        .size === 0 ? (
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                        ) : null}
                    {this.props.documents
                        .filter(__ => __.document === _.id && __.file.document_option == docOption.split("-")[1])
                        .sort((a, b) =>
                            a.modified_date.isBefore(b.modified_date)
                                ? 1
                                : -1
                        )
                        .map(__ => (
                            <ListItem
                                key={__.id}
                                actions={
                                    ((this.props.deletable && this.props.editDocumentInCase) 
                                    || ((this.props.adminGroup && this.props.adminGroup.includes(11)) && (this.props.currentCaseTask && this.props.currentCaseTask[0].this_stage == 10)))
                                        ? [
                                            <Button
                                                type="link"
                                                onClick={this.props.viewDocument.bind(
                                                    null,
                                                    __.file && __.file.id,
                                                    __.file && __.file.file_name,
                                                    __.file && __.file.file
                                                )}
                                                key={"view-button"}
                                            >
                                                    View
                                            </Button>,
                                            <Button
                                                type="link"
                                                onClick={this.deactivateDocument.bind(
                                                    null,
                                                    __.id
                                                )}
                                                key={"deactivate-button"}
                                                disabled={this.props.recreditViewOnlyPermission}
                                            >
                                                    Remove
                                            </Button>
                                        ] :
                                        [
                                            <Button
                                                type="link"
                                                onClick={this.props.viewDocument.bind(
                                                    null,
                                                    __.file && __.file.id,
                                                    __.file && __.file.file_name,
                                                    __.file && __.file.file
                                                )}
                                                key={"view-button"}
                                            >
                                                View
                                            </Button>
                                        ]
                                }
                            >
                                {__ && __.file && __.file.file_name}
                            </ListItem>
                        ))}
                </AntList>
            );
        }
        return (
            <AntList itemLayout={"horizontal"}>
                {this.props.documents.filter(__ => __.document ===  _.id)
                    .size === 0 ? (
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    ) : null}
                {this.props.documents
                    .filter(__ => __.document === _.id)
                    .sort((a, b) =>
                        a.modified_date.isBefore(b.modified_date)
                            ? 1
                            : -1
                    )
                    .map(__ => (
                        <ListItem
                            key={__.id}
                            actions={
                                ((this.props.deletable && this.props.editDocumentInCase)    
                                || ((this.props.adminGroup && this.props.adminGroup.includes(11)) && (this.props.currentCaseTask && this.props.currentCaseTask[0].this_stage == 10))
                                )
                                    ? [
                                        <Button
                                            type="link"
                                            onClick={this.props.viewDocument.bind(
                                                null,
                                                __.file && __.file.id,
                                                __.file && __.file.file_name,
                                                __.file && __.file.file
                                            )}
                                            key={"view-button"}
                                        >
                                                View
                                        </Button>,
                                        <Button
                                            type="link"
                                            onClick={this.deactivateDocument.bind(
                                                null,
                                                __.id
                                            )}
                                            key={"deactivate-button"}
                                            disabled={this.props.recreditViewOnlyPermission}
                                        >
                                                Remove
                                        </Button>
                                    ] :
                                    [
                                        <Button
                                            type="link"
                                            onClick={this.props.viewDocument.bind(
                                                null,
                                                __.file && __.file.id,
                                                __.file && __.file.file_name,
                                                __.file && __.file.file
                                            )}
                                            key={"view-button"}
                                        >
                                            View
                                        </Button>
                                    ]
                            }
                        >
                            {__ && __.file && __.file.file_name}
                        </ListItem>
                    ))}
            </AntList>
        );
    }

    render() {
        return this.props.categories ? (
            this.props.categories.map(_ => (
                !this.props.droppable && this.props.documents.find(__ => __.document === _.id) ?
                    <React.Fragment>
                        {_.document_document_type_option.length ? _.document_document_type_option.map(docOption => {
                            return <DropTargetCard
                                type={"inner"}
                                className={"no-shadow mb-5"}
                                key={_.document_name}
                                title={docOption.id  == "12" ? "Aadhar-Front M" : "Aadhar-Back M"}
                                caseId={this.props.caseId}
                                companyId={this.props.companyId}
                                associateId={this.props.associateId}
                                bankId={this.props.bankId}
                                documentId={`${_.id}-${docOption.id}`}
                                documentType={_.document_type}
                                canDrop={() => (this.props.droppable && this.props.editDocumentInCase) || ((this.props.adminGroup && this.props.adminGroup.includes(11)) && (this.props.currentCaseTask && this.props.currentCaseTask[0].this_stage == 10))}
                                extra={(this.props.deletable && this.props.editDocumentInCase && this.props.isUserAllowedToEdit) || 
                                    ((this.props.adminGroup && this.props.adminGroup.includes(11)) && (this.props.currentCaseTask && this.props.currentCaseTask[0].this_stage == 10)) ? [
                                    <DirectFileUpload
                                        key={"direct-upload"}
                                        companyId={this.props.companyId}
                                        uploadFiles={this.uploadAndAttachFile.bind(
                                            null,
                                            `${_.id}-${docOption.id}`,
                                            _.document_type
                                        )}
                                        recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                    />
                                ] : null}
                            >
                                {this.renderList(_ , `${_.id}-${docOption.id}`)}
                            </DropTargetCard>;
                        }) : <DropTargetCard
                            type={"inner"}
                            className={"no-shadow mb-5"}
                            key={_.document_name}
                            title={_.document_name}
                            caseId={this.props.caseId}
                            companyId={this.props.companyId}
                            associateId={this.props.associateId}
                            bankId={this.props.bankId}
                            documentId={_.id}
                            documentType={_.document_type}
                            canDrop={() => (this.props.droppable && this.props.editDocumentInCase) || ((this.props.adminGroup && this.props.adminGroup.includes(11)) && (this.props.currentCaseTask && this.props.currentCaseTask[0].this_stage == 10))}
                            extra={this.props.deletable && this.props.editDocumentInCase && this.props.isUserAllowedToEdit ? [
                                <DirectFileUpload
                                    key={"direct-upload"}
                                    companyId={this.props.companyId}
                                    uploadFiles={this.uploadAndAttachFile.bind(
                                        null,
                                        _.id,
                                        _.document_type
                                    )}
                                    recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                />
                            ] : null}
                        >
                            {this.renderList(_)}
                        </DropTargetCard>} </React.Fragment>: this.props.droppable && this.props.editDocumentInCase ? (
                        <React.Fragment>
                            {_.document_document_type_option.length ? _.document_document_type_option.map(docOption => {
                                return <DropTargetCard
                                    type={"inner"}
                                    className={"no-shadow mb-5"}
                                    key={_.document_name}
                                    title={docOption.id  == "12" ? "Aadhar-Front M" : "Aadhar-Back M"}
                                    caseId={this.props.caseId}
                                    companyId={this.props.companyId}
                                    associateId={this.props.associateId}
                                    bankId={this.props.bankId}
                                    documentId={`${_.id}-${docOption.id}`}
                                    documentType={_.document_type}
                                    canDrop={() => (this.props.droppable && this.props.editDocumentInCase && this.props.isUserAllowedToEdit) ||  ((this.props.adminGroup && this.props.adminGroup.includes(11)) && (this.props.currentCaseTask && this.props.currentCaseTask[0].this_stage == 10))}
                                    extra={this.props.deletable ? [
                                        <DirectFileUpload
                                            key={"direct-upload"}
                                            companyId={this.props.companyId}
                                            uploadFiles={this.uploadAndAttachFile.bind(
                                                null,
                                                `${_.id}-${docOption.id}`,
                                                _.document_type
                                            )}
                                            recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                        />
                                    ] : null}
                                >
                                    {this.renderList(_ , `${_.id}-${docOption.id}`)}
                                </DropTargetCard>;
                            }) : <DropTargetCard
                                type={"inner"}
                                className={"no-shadow mb-5"}
                                key={_.document_name}
                                title={_.document_name}
                                caseId={this.props.caseId}
                                companyId={this.props.companyId}
                                associateId={this.props.associateId}
                                bankId={this.props.bankId}
                                documentId={_.id}
                                documentType={_.document_type}
                                canDrop={() => (this.props.droppable && this.props.editDocumentInCase && this.props.isUserAllowedToEdit) || ((this.props.adminGroup && this.props.adminGroup.includes(11)) && (this.props.currentCaseTask && this.props.currentCaseTask[0].this_stage == 10))}
                                extra={this.props.deletable ? [
                                    <DirectFileUpload
                                        key={"direct-upload"}
                                        companyId={this.props.companyId}
                                        uploadFiles={this.uploadAndAttachFile.bind(
                                            null,
                                            _.id,
                                            _.document_type
                                        )}
                                        recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                    />
                                ] : null}
                            >
                                {this.renderList(_)}
                            </DropTargetCard>}
                            {/* <DropTargetCard
                            type={"inner"}
                            className={"no-shadow mb-5"}
                            key={_.document_name}
                            title={_.document_name}
                            caseId={this.props.caseId}
                            companyId={this.props.companyId}
                            associateId={this.props.associateId}
                            bankId={this.props.bankId}
                            documentId={_.id}
                            documentType={_.document_type}
                            canDrop={() => this.props.droppable && this.props.editDocumentInCase && this.props.isUserAllowedToEdit}
                            extra={this.props.deletable ? [
                                <DirectFileUpload
                                    key={"direct-upload"}
                                    companyId={this.props.companyId}
                                    uploadFiles={this.uploadAndAttachFile.bind(
                                        null,
                                        _.id,
                                        _.document_type
                                    )}
                                />
                            ] : null}
                        >
                            {this.renderList(_)}
                        </DropTargetCard> */}
                        </React.Fragment>
                    ) : <DropTargetCard
                    type={"inner"}
                    className={"no-shadow mb-5"}
                    key={_.document_name}
                    title={_.document_name}
                    caseId={this.props.caseId}
                    companyId={this.props.companyId}
                    associateId={this.props.associateId}
                    bankId={this.props.bankId}
                    documentId={_.id}
                    documentType={_.document_type}
                    canDrop={() => (this.props.droppable && this.props.editDocumentInCase) || ((this.props.adminGroup && this.props.adminGroup.includes(11)) && (this.props.currentCaseTask && this.props.currentCaseTask[0].this_stage == 10))}
                    extra={(this.props.deletable && this.props.editDocumentInCase && this.props.isUserAllowedToEdit) || 
                        ((this.props.adminGroup && this.props.adminGroup.includes(11)) && (this.props.currentCaseTask && this.props.currentCaseTask[0].this_stage == 10)) ? [
                        <DirectFileUpload
                            key={"direct-upload"}
                            companyId={this.props.companyId}
                            uploadFiles={this.uploadAndAttachFile.bind(
                                null,
                                _.id,
                                _.document_type
                            )}
                            recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                        />
                    ] : null}
                >
                    {this.renderList(_)}
                </DropTargetCard>)
            )
        ) : (
            <Empty />
        );
    }
}

DocumentsList.propTypes = {
    droppable: PropTypes.boolean,
    deletable: PropTypes.boolean,
    isOver: PropTypes.boolean,
    categories: PropTypes.array,
    documents: PropTypes.object,
    caseId: PropTypes.number,
    companyId: PropTypes.number,
    associateId: PropTypes.number,
    bankId: PropTypes.number,
    updateDocument: PropTypes.func,
    uploadFiles: PropTypes.func,
    attachDocument: PropTypes.func,
    viewDocument: PropTypes.func,
    isRiskApprover: PropTypes.bool,
    editDocumentInCase: PropTypes.bool,
    isUserAllowedToEdit: PropTypes.bool,
    recreditViewOnlyPermission: PropTypes.bool,
};


DocumentsList.defaultProps = {
    isRiskApprover: false
};

class DocumentsTab extends React.Component {
    state = {
        checklistTabs: List([]),
        fileViewId: null,
        fileName: null,
        fileUrl: null,
        selectedSanctionType: "pre-sanction",
        showDoc: false,
        showRemarks: false,
        remarks: null,
        selectedFile: null,
        requestModal: false,
        requestedDocs: null
    };
    async handleChecklistFetch() {
        if (
            this.props.caseId &&
            (!this.props.checklist ||
                this.props.checklist.getIn([this.state.selectedSanctionType, this.props.caseId,"status"]) === STATE_STATUS.UNFETCHED)
        ) {
            this.props.fetchDocumentsChecklist(
                this.props.caseId,
                this.state.selectedSanctionType
            );
        }
    }
    async handleFilesFetch() {
        if (
            this.props.companyId &&
            (!this.props.files ||
                this.props.files.get("status") === STATE_STATUS.UNFETCHED)
        ) {
            this.props.fetchCompanyDocuments(
                this.props.caseId,
                this.props.companyId
            );
        }
    }
    async handleDocumentsFetch() {
        if (
            this.props.caseId &&
            (!this.props.documents ||
                this.props.documents.get("status") === STATE_STATUS.UNFETCHED)
        ) {
            this.props.fetchCaseDocuments(
                this.props.caseId,
                this.props.companyId
            );
        }
    }

    async handleFetchDocumentTypes() {
        if(this.props.docMasterListStatus === STATE_STATUS.UNFETCHED) {
            this.props.fetchDocumentTypes();
        }
    }

    componentDidMount() {
        this.handleChecklistFetch();
        this.handleDocumentsFetch();
        this.handleFilesFetch();
        this.handleFetchDocumentTypes();
    }

    componentDidUpdate() {
        this.handleChecklistFetch();
        this.handleDocumentsFetch();
        this.handleFilesFetch();
    }
    isLoading = () => {
        if (
            !this.props.documents ||
            this.props.documents.get("status") !== STATE_STATUS.FETCHED
        ) {
            return true;
        }
        if (
            !this.props.files ||
            this.props.files.get("status") !== STATE_STATUS.FETCHED
        ) {
            return true;
        }
        if (
            !this.props.checklist ||
            this.props.checklist.getIn([this.state.selectedSanctionType, this.props.caseId,"status"]) !== STATE_STATUS.FETCHED
        ) {
            return true;
        }
        return false;
    };
    viewDocument = (fileViewId = null, fileName = null, fileUrl = null) => {
        this.setState({
            visible: fileViewId ? true : false,
            fileViewId,
            fileName,
            fileUrl
        });
    };

    changeSanctionType = val => {
        this.setState({
            selectedSanctionType: val
        }, () => {
            this.handleChecklistFetch();
        });
    }

    invalidateDoc = () => {
        this.setState({
            showDoc: false,
            showRemarks: false
        }, () => {
            this.props.invalidateDocument(
                this.props.companyId,
                this.state.selectedFile && this.state.selectedFile.id,
                this.state.selectedFile
                    .set("remarks", this.state.remarks)
                    .set("file_name", this.state.fileName),
                this.props.caseId
            );
        });
    }

    showDocument = () => {
        const url = this.state.selectedFile && this.state.selectedFile.file;
        if (["jpg", "jpeg", "gif", "bmp", "png"].includes(url && url.split(".").reverse()[0])) {
            return (<img width={"100%"} src={url} />);
        }
        return (<iframe width={"1000"} height={"1000"} src={url} />);
    }

    getName = (editDocumentAttached) => {
        if(editDocumentAttached) {
            return (
                <Paragraph
                    editable={{
                        onChange: (value) => {
                            this.setState({
                                fileName: value
                            });
                        }
                    }}
                >
                    {this.state.fileName}
                </Paragraph>
            );
        } else {
            return this.state.fileName;
        }
    }

    render() {
        const viewDocumentAttached = this.props.permissionContext && this.props.permissionContext.get("view_document_attached");
        const editDocumentAttached = this.props.permissionContext && this.props.permissionContext.get("edit_document_attached");
        const viewDocumentInCase = this.props.permissionContext && this.props.permissionContext.get("view_document_in_case");
        const editDocumentInCase = this.props.permissionContext && this.props.permissionContext.get("edit_document_in_case");
        const bankStatementsNotAttachedToAccounts = this.props.documents.get("data").map(_ =>
            _.get("data")
        )
            .filter(
                _ => _.company_bank ===
                    null && _.document === 14
            )
            .toList();
        let caseAssociates = this.props.caseAssociates && this.props.caseAssociates.filter(_ => _.type == 1).map(_ => Number(_.company_associate.id));
        let caseGurantors = this.props.caseAssociates && this.props.caseAssociates.filter(_ => _.type == 2).map(_ => Number(_.company_associate.id));
        const recreditViewOnlyPermission= this.props.recreditViewOnlyPermission;
        return (
            <React.Fragment>
                
                <Modal
                    visible={this.state.visible}
                    onCancel={this.viewDocument.bind(null, null, null, null)}
                    title={this.state.fileName}
                    okText={null}
                    cancelText={null}
                    width={700}
                >
                    <DocumentViewer
                        url={this.state.fileUrl}
                        width={600}
                        height={800}
                    />
                </Modal>
                <Modal
                    visible={this.state.showDoc}
                    onCancel={() => {
                        if(this.props.isUserAllowedToEdit && editDocumentAttached && this.state.selectedFile && (!this.state.selectedFile.is_valid || this.state.selectedFile.file_name !== this.state.fileName)) {
                            this.setState({
                                showDoc: false,
                                selectedFile: this.state.selectedFile
                                    .set("is_valid", true)
                                    .set("remarks", null)
                                    .set("file_name", this.state.fileName)
                            }, () => {
                                this.invalidateDoc();
                            });
                        } else {
                            this.setState({
                                showDoc: false
                            });
                        }
                    }}
                    onOk={() => {
                        if(this.props.isUserAllowedToEdit && editDocumentAttached) {
                            this.setState({
                                showRemarks: true
                            });
                        } else {
                            this.setState({
                                showDoc: false
                            });
                        }
                    }}
                    title={this.getName(editDocumentAttached)}
                    okText={this.props.isUserAllowedToEdit && editDocumentAttached ? "Reject" : "OK"}
                    cancelText={this.props.isUserAllowedToEdit && editDocumentAttached ? "Accept": "Cancel"}
                    width={"fit-content"}
                >
                    <DocumentViewer
                        url={this.state.fileUrl}
                        width={600}
                        height={800}
                    />
                </Modal>
                <Modal
                    visible={this.state.showRemarks}
                    title={"Remarks"}
                    onOk={this.invalidateDoc}
                    onCancel={() => {
                        this.setState({
                            showRemarks: false,
                            showDoc: false
                        });
                    }}
                >
                    <Input.TextArea onChange={({target : {value}}) => {
                        this.setState({
                            remarks: value
                        });
                    }} />
                </Modal>
                <LoaderSkeleton loading={this.isLoading()}>
                    {/* <Row>
                        <Col span={24} className={"p-10 mb-10"}>
                            <Button type={"dashed"} onClick={this.openRequestModal}>Request Documents</Button>
                        </Col>
                    </Row> */}
                    <Row>
                        {viewDocumentInCase ? (
                            <Col span={16} className={"p-10"}>
                                <Tabs tabPosition={"left"} type={"line"}>
                                    {(
                                        (this.props.checklist &&
                                            this.props.checklist.getIn([this.state.selectedSanctionType, this.props.caseId,"data"])) ||
                                        List([])
                                    ).map(_ => {
                                        if (_.name === "KYC Applicants") {
                                            return (
                                                <Tabs.TabPane
                                                    key={_.name}
                                                    tab={_.name}
                                                >
                                                    {this.props.company && this.props.company.associates
                                                        .size === 0 ? (
                                                            <Empty
                                                                image={
                                                                    Empty.PRESENTED_IMAGE_SIMPLE
                                                                }
                                                            />
                                                        ) : null}
                                                    {this.props.company && this.props.company.associates
                                                        .filter(
                                                            _ =>
                                                                caseAssociates && 
                                                                caseAssociates.includes(Number(_.id))
                                                        )
                                                        .map(associate => (
                                                            <Card
                                                                key={associate.id}
                                                                // className={
                                                                //     // "mt-5 mr-5 mb-5"
                                                                // }
                                                                className={
                                                                    "no-border-transparent",
                                                                    "document-card"
                                                                }
                                                                title={
                                                                    associate.name
                                                                }
                                                                extra={[
                                                                    "Drop files in the each section to attach"
                                                                ]}
                                                            >
                                                                <DocumentsList
                                                                    adminGroup={this.props.adminGroup}
                                                                    currentCaseTask = {this.props.currentCaseTask}                                                                
                                                                    isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                                                                    categories={
                                                                        _.documents
                                                                    }
                                                                    caseId={
                                                                        this.props
                                                                            .caseId
                                                                    }
                                                                    companyId={
                                                                        this.props
                                                                            .companyId
                                                                    }
                                                                    editDocumentInCase={editDocumentInCase}
                                                                    associateId={
                                                                        associate.id
                                                                    }
                                                                    updateDocument={
                                                                        this.props
                                                                            .updateDocument
                                                                    }
                                                                    documents={this.props.documents
                                                                        .get("data")
                                                                        .map(_ =>
                                                                            _.get(
                                                                                "data"
                                                                            )
                                                                        )
                                                                        .filter(
                                                                            _ =>
                                                                                _.associate ===
                                                                                associate.id
                                                                        )
                                                                        .toList()}
                                                                    droppable={
                                                                        this.props
                                                                            .DOCUMENTS_EDIT &&
                                                                            this.props.isUserAllowedToEdit
                                                                    }
                                                                    deletable={
                                                                        this.props
                                                                            .DOCUMENTS_EDIT &&
                                                                            this.props.isUserAllowedToEdit
                                                                    }
                                                                    isRiskApprover={this.props.isRiskApprover}
                                                                    attachDocument={
                                                                        this.props
                                                                            .attachDocument
                                                                    }
                                                                    uploadFiles={this.props.uploadDocuments.bind(
                                                                        null,
                                                                        this.props
                                                                            .caseId,
                                                                        this.props
                                                                            .companyId
                                                                    )}
                                                                    viewDocument={
                                                                        this
                                                                            .viewDocument
                                                                    }
                                                                    recreditViewOnlyPermission={recreditViewOnlyPermission}
                                                                />
                                                            </Card>
                                                        ))
                                                        .toList()}
                                                </Tabs.TabPane>
                                            );
                                        }
                                        if (_.name === "Cibil Document") {
                                            return (
                                                <Tabs.TabPane
                                                    key={_.name}
                                                    tab={_.name}
                                                >
                                                    {this.props.company && this.props.company.associates
                                                        .size === 0 ? (
                                                            <Empty
                                                                image={
                                                                    Empty.PRESENTED_IMAGE_SIMPLE
                                                                }
                                                            />
                                                        ) : null}
                                                    {this.props.company && this.props.company.associates
                                                        .filter(
                                                            _ =>
                                                                caseAssociates && 
                                                                caseAssociates.includes(Number(_.id))
                                                        )
                                                        .map(associate => (
                                                            <Card
                                                                key={associate.id}
                                                                // className={
                                                                //     // "mt-5 mr-5 mb-5"
                                                                // }
                                                                className={
                                                                    "no-border-transparent",
                                                                    "document-card"
                                                                }
                                                                title={
                                                                    associate.name
                                                                }
                                                                extra={[
                                                                    "Drop files in the each section to attach"
                                                                ]}
                                                            >
                                                                <DocumentsList
                                                                    adminGroup={this.props.adminGroup}
                                                                    currentCaseTask = {this.props.currentCaseTask}                                                                                                                                
                                                                    isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                                                                    categories={
                                                                        _.documents
                                                                    }
                                                                    caseId={
                                                                        this.props
                                                                            .caseId
                                                                    }
                                                                    companyId={
                                                                        this.props
                                                                            .companyId
                                                                    }
                                                                    editDocumentInCase={editDocumentInCase}
                                                                    associateId={
                                                                        associate.id
                                                                    }
                                                                    updateDocument={
                                                                        this.props
                                                                            .updateDocument
                                                                    }
                                                                    documents={this.props.documents
                                                                        .get("data")
                                                                        .map(_ =>
                                                                            _.get(
                                                                                "data"
                                                                            )
                                                                        )
                                                                        .filter(
                                                                            _ =>
                                                                                _.associate ===
                                                                                associate.id
                                                                        )
                                                                        .toList()}
                                                                    droppable={
                                                                        this.props
                                                                            .DOCUMENTS_EDIT &&
                                                                            this.props.isUserAllowedToEdit
                                                                    }
                                                                    deletable={
                                                                        this.props
                                                                            .DOCUMENTS_EDIT &&
                                                                            this.props.isUserAllowedToEdit
                                                                    }
                                                                    isRiskApprover={this.props.isRiskApprover}
                                                                    attachDocument={
                                                                        this.props
                                                                            .attachDocument
                                                                    }
                                                                    uploadFiles={this.props.uploadDocuments.bind(
                                                                        null,
                                                                        this.props
                                                                            .caseId,
                                                                        this.props
                                                                            .companyId
                                                                    )}
                                                                    viewDocument={
                                                                        this
                                                                            .viewDocument
                                                                    }
                                                                    recreditViewOnlyPermission={recreditViewOnlyPermission}
                                                                />
                                                            </Card>
                                                        ))
                                                        .toList()}
                                                </Tabs.TabPane>
                                            );
                                        }
                                        if (_.name === "KYC Guarantor") {
                                            return (
                                                <Tabs.TabPane
                                                    key={_.name}
                                                    tab={_.name}
                                                >
                                                    {this.props.company && this.props.company.associates.filter(
                                                        _ => _.type === 2
                                                    ).size === 0 ? (
                                                            <Empty
                                                                image={
                                                                    Empty.PRESENTED_IMAGE_SIMPLE
                                                                }
                                                            />
                                                        ) : null}
                                                    {this.props.company.associates
                                                        .filter(
                                                            _ =>
                                                                caseGurantors && 
                                                                caseGurantors.includes(Number(_.id))
                                                        )
                                                        .map(associate => (
                                                            <Card
                                                                key={associate.id}
                                                                // className={
                                                                //     // "mt-5 mr-5 mb-5"
                                                                // }
                                                                className={
                                                                    "no-border-transparent",
                                                                    "document-card"
                                                                }
                                                                title={
                                                                    associate.name
                                                                }
                                                            >
                                                                <DocumentsList
                                                                    adminGroup={this.props.adminGroup}
                                                                    currentCaseTask = {this.props.currentCaseTask}                                                                                                                                
                                                                    kycGuarantor
                                                                    isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                                                                    categories={
                                                                        kycGuarantor.documents
                                                                    }
                                                                    caseId={
                                                                        this.props
                                                                            .caseId
                                                                    }
                                                                    companyId={
                                                                        this.props
                                                                            .companyId
                                                                    }
                                                                    associateId={
                                                                        associate.id
                                                                    }
                                                                    editDocumentInCase={editDocumentInCase}
                                                                    documents={this.props.documents
                                                                        .get("data")
                                                                        .map(_ =>
                                                                            _.get(
                                                                                "data"
                                                                            )
                                                                        )
                                                                        .filter(
                                                                            _ =>
                                                                                _.associate ===
                                                                                associate.id
                                                                        )
                                                                        .toList()}
                                                                    droppable={
                                                                        this.props
                                                                            .DOCUMENTS_EDIT &&
                                                                            this.props.isUserAllowedToEdit
                                                                    }
                                                                    updateDocument={
                                                                        this.props
                                                                            .updateDocument
                                                                    }
                                                                    deletable={
                                                                        this.props
                                                                            .DOCUMENTS_EDIT &&
                                                                            this.props.isUserAllowedToEdit
                                                                    }
                                                                    isRiskApprover={this.props.isRiskApprover}
                                                                    attachDocument={
                                                                        this.props
                                                                            .attachDocument
                                                                    }
                                                                    uploadFiles={this.props.uploadDocuments.bind(
                                                                        null,
                                                                        this.props
                                                                            .caseId,
                                                                        this.props
                                                                            .companyId
                                                                    )}
                                                                    viewDocument={
                                                                        this
                                                                            .viewDocument
                                                                    }
                                                                    recreditViewOnlyPermission={recreditViewOnlyPermission}
                                                                />
                                                            </Card>
                                                        ))
                                                        .toList()}
                                                </Tabs.TabPane>
                                            );
                                        }
                                        if (_.name === "Bank Statements") {
                                            return (
                                                <Tabs.TabPane
                                                    key={_.name}
                                                    tab={_.name}
                                                >
                                                    {!this.props.company.bank_accounts || this.props.company
                                                        .bank_accounts.size ===
                                                    0 ? (
                                                            <Empty
                                                                image={
                                                                    Empty.PRESENTED_IMAGE_SIMPLE
                                                                }
                                                            />
                                                        ) : null}
                                                    {this.props.company.bank_accounts && this.props.company.bank_accounts
                                                        .map(bank_account => (
                                                            <Card
                                                                key={
                                                                    bank_account.id
                                                                }
                                                                className={
                                                                    "no-border-transparent",
                                                                    "document-card"
                                                                }
                                                                // className={
                                                                //     // "mt-5 mr-5 mb-5"
                                                                // }
                                                                title={
                                                                    bank_account.name
                                                                }
                                                            >
                                                                <DocumentsList
                                                                    adminGroup={this.props.adminGroup}
                                                                    currentCaseTask = {this.props.currentCaseTask}                                                                                                                                
                                                                    isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                                                                    categories={
                                                                        _.documents
                                                                    }
                                                                    caseId={
                                                                        this.props
                                                                            .caseId
                                                                    }
                                                                    companyId={
                                                                        this.props
                                                                            .companyId
                                                                    }
                                                                    editDocumentInCase={editDocumentInCase}
                                                                    bankId={
                                                                        bank_account.id
                                                                    }
                                                                    documents={this.props.documents
                                                                        .get("data")
                                                                        .map(_ =>
                                                                            _.get(
                                                                                "data"
                                                                            )
                                                                        )
                                                                        .filter(
                                                                            _ =>
                                                                                _.company_bank ===
                                                                                bank_account.id
                                                                        )
                                                                        .toList()}
                                                                    droppable={
                                                                        this.props
                                                                            .DOCUMENTS_EDIT &&
                                                                            this.props.isUserAllowedToEdit
                                                                    }
                                                                    updateDocument={
                                                                        this.props
                                                                            .updateDocument
                                                                    }
                                                                    deletable={
                                                                        this.props
                                                                            .DOCUMENTS_EDIT &&
                                                                            this.props.isUserAllowedToEdit
                                                                    }
                                                                    isRiskApprover={this.props.isRiskApprover}
                                                                    attachDocument={
                                                                        this.props
                                                                            .attachDocument
                                                                    }
                                                                    uploadFiles={this.props.uploadDocuments.bind(
                                                                        null,
                                                                        this.props
                                                                            .caseId,
                                                                        this.props
                                                                            .companyId
                                                                    )}
                                                                    viewDocument={
                                                                        this
                                                                            .viewDocument
                                                                    }
                                                                    recreditViewOnlyPermission={recreditViewOnlyPermission}
                                                                />
                                                            </Card>
                                                        ))
                                                        .toList()}
                                                    {bankStatementsNotAttachedToAccounts && bankStatementsNotAttachedToAccounts.size ? (
                                                        <Card
                                                            className={
                                                                "no-border-transparent",
                                                                "document-card"
                                                            }
                                                            title={_.name}
                                                        >
                                                            <DocumentsList
                                                                adminGroup={this.props.adminGroup}
                                                                currentCaseTask = {this.props.currentCaseTask}                                                                                                                            
                                                                isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                                                                categories={_.documents}
                                                                caseId={
                                                                    this.props.caseId
                                                                }
                                                                companyId={
                                                                    this.props.companyId
                                                                }
                                                                documents={bankStatementsNotAttachedToAccounts}
                                                                editDocumentInCase={editDocumentInCase}
                                                                droppable={
                                                                    false
                                                                }
                                                                deletable={
                                                                    this.props
                                                                        .DOCUMENTS_EDIT &&
                                                                        this.props.isUserAllowedToEdit
                                                                }
                                                                updateDocument={
                                                                    this.props
                                                                        .updateDocument
                                                                }
                                                                attachDocument={
                                                                    this.props
                                                                        .attachDocument
                                                                }
                                                                uploadFiles={this.props.uploadDocuments.bind(
                                                                    null,
                                                                    this.props.caseId,
                                                                    this.props.companyId
                                                                )}
                                                                viewDocument={
                                                                    this.viewDocument
                                                                }
                                                                recreditViewOnlyPermission={recreditViewOnlyPermission}
                                                            />
                                                        </Card>
                                                    ) : null}
                                                </Tabs.TabPane>
                                            );
                                        }
                                        return (
                                            <Tabs.TabPane key={_.name} tab={_.name}>
                                                <Card
                                                    className={
                                                        "no-border-transparent",
                                                        "document-card"
                                                    }
                                                    title={_.name}
                                                >
                                                    {
                                                        <DocumentsList
                                                            adminGroup={this.props.adminGroup}
                                                            currentCaseTask = {this.props.currentCaseTask}
                                                            isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                                                            categories={_.documents}
                                                            caseId={
                                                                this.props.caseId
                                                            }
                                                            companyId={
                                                                this.props.companyId
                                                            }
                                                            documents={this.props.documents
                                                                .get("data")
                                                                .map(_ =>
                                                                    _.get("data")
                                                                )
                                                                .toList()}
                                                            editDocumentInCase={editDocumentInCase}
                                                            droppable={
                                                                this.props
                                                                    .DOCUMENTS_EDIT &&
                                                                this.props.isUserAllowedToEdit
                                                            }
                                                            deletable={
                                                                this.props
                                                                    .DOCUMENTS_EDIT &&
                                                                    this.props.isUserAllowedToEdit
                                                            }
                                                            updateDocument={
                                                                this.props
                                                                    .updateDocument
                                                            }
                                                            attachDocument={
                                                                this.props
                                                                    .attachDocument
                                                            }
                                                            uploadFiles={this.props.uploadDocuments.bind(
                                                                null,
                                                                this.props.caseId,
                                                                this.props.companyId
                                                            )}
                                                            viewDocument={
                                                                this.viewDocument
                                                            }
                                                            recreditViewOnlyPermission={recreditViewOnlyPermission}
                                                        />
                                                    }
                                                </Card>
                                            </Tabs.TabPane>
                                        );
                                    })}
                                </Tabs>
                            </Col>

                        ) : null}
                        {viewDocumentAttached ? (
                            <Col span={viewDocumentInCase ? 8 : 12} className={"p-10"}>
                                <FileList
                                    companyId={this.props.companyId}
                                    caseId={this.props.caseId}
                                    invalidateDocument={(file) => {
                                        this.setState({
                                            selectedFile: file.set("is_active", false),
                                            showRemarks: true,
                                            fileName: file.file_name
                                        });
                                    }}
                                    changeName={(file) => {
                                        this.setState({
                                            selectedFile: file,
                                            fileName: file.file_name
                                        }, () => {
                                            this.invalidateDoc();
                                        });
                                    }}
                                    editDocumentAttached={editDocumentAttached}
                                    viewDoc={(file) => this.viewDocument(
                                        file && file.id,
                                        file && file.file_name,
                                        file && file.file
                                    )}
                                    isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                                    files={
                                        this.props.files &&
                                        this.props.files.get("data").toList()
                                    }
                                    uploads={this.props.uploads || new List([])}
                                    attachDocument={this.props.attachDocument}
                                    uploadFiles={this.props.uploadDocuments.bind(
                                        null,
                                        this.props.caseId,
                                        this.props.companyId
                                    )}
                                    draggable={this.props.DOCUMENTS_EDIT || viewDocumentAttached}
                                    recreditViewOnlyPermission={recreditViewOnlyPermission}
                                />
                            </Col>
                        ) : null}
                    </Row>
                </LoaderSkeleton>
            </React.Fragment>
        );
    }
}

DocumentsTab.propTypes = {
    documentsType: PropTypes.string,
    caseId: PropTypes.number,
    companyId: PropTypes.number,
    checklist: PropTypes.object,
    files: PropTypes.object,
    documents: PropTypes.object,
    uploads: PropTypes.object,
    company: PropTypes.object,
    fetchDocumentsChecklist: PropTypes.func,
    fetchCaseDocuments: PropTypes.func,
    fetchCompanyDocuments: PropTypes.func,
    uploadDocuments: PropTypes.func,
    attachDocument: PropTypes.func,
    updateDocument: PropTypes.func,
    DOCUMENTS_EDIT: PropTypes.bool,
    isRiskApprover: PropTypes.bool,
    location: PropTypes.object,
    isUserAllowedToEdit: PropTypes.bool,
    invalidateDocument: PropTypes.func,
    permissionContext: PropTypes.object,
    docMasterListStatus: PropTypes.string,
    docMasterList: PropTypes.array,
    fetchDocumentTypes: PropTypes.func,
    requestDocuments: PropTypes.func,
    caseAssociates: PropTypes.array,
    caseAssociatesStatus: PropTypes.string,
    recreditViewOnlyPermission: PropTypes.bool,
};

DocumentsTab.defaultProps = {
    isRiskApprover: true
};

const mapStateToProps = (state, props) => ({
    currentCaseTask: state.caseDetails.getIn([Number(props.caseId), "data", "current_case_task"]),
    adminGroup: state.user.getIn(["data", "stage_admin"]),
    checklist: state.documents.get("checklist"),
    files: state.documents.getIn(["company_documents", props.companyId]),
    docMasterListStatus: state.documents.getIn([
        "documentsMasterList",
        "status"
    ]),
    docMasterList: state.documents.getIn(["documentsMasterList", "data"]),
    documents: state.documents.getIn(["case_documents", props.caseId]),
    company: state.companies.getIn([props.companyId, "data"]),
    uploads: state.documents.getIn(["uploads", props.companyId]),
    caseAssociatesStatus: state.caseDetails.getIn([Number(props.caseId), "caseAssociates", "status"]),
    caseAssociates: state.caseDetails.getIn([props.caseId, "caseAssociates", "data"])
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchDocumentsChecklist,
            uploadDocuments,
            fetchCaseDocuments,
            fetchCompanyDocuments,
            attachDocument,
            updateDocument,
            invalidateDocument,
            fetchDocumentTypes,
            requestDocuments
        },
        dispatch
    );

const ReduxWrappedComponent = connect(
    mapStateToProps,
    mapDispatchToProps
)(DocumentsTab);

export default PermissionContextManager({
    permission: UI_PERMISSIONS.DOCUMENTS_VIEW,
    propsPermissions: {
        DOCUMENTS_EDIT: UI_PERMISSIONS.DOCUMENTS_EDIT
    }
})(ReduxWrappedComponent);
